import { required, email, integer } from 'vuelidate/lib/validators';

const validations = {
  title: {
    required,
  },
  paymentTypes: {
    required,
  },
  code: {
    required,
  },
  address: {
    required,
  },
  countryId: {
    required,
  },
  townId: {
    required,
  },
  // discount: {
  //   required,
  // },
  email: {
    required,
    email,
  },
  phone: {
    required,
  },
  // web: {
  //   required,
  // },
  idNumber: {
    integer,
  },
  delayedPaymentInDays: {
    required,
    integer
  },
  masterId: {
    required
  }
};

export default validations;